// extracted by mini-css-extract-plugin
export var calculatedBadge = "_x3-8";
export var container = "_x3-0";
export var radioDot = "_x3-5";
export var radioDotSelected = "_x3-6";
export var row = "_x3-1";
export var rowFirst = "_x3-2";
export var rowLast = "_x3-3";
export var rowSelected = "_x3-4";
export var strikethrough = "_x3-7";